import { 
    ChartLine, 
    BookOpen, 
    GraduationCap, 
    TrendingUp, 
    Twitter, 
    Link, 
    Headphones 
} from 'lucide-react';

export const KnowledgeData = [
    {
      id: 'insights',
      title: 'Insights: Wealth Blog',
      description: 'In-depth analysis on wealth creation strategies',
      Icon: ChartLine,
      category: 'Blogs',
      externalLink: 'https://maxiomwealth.com/blog/category/wealth-creation-portfolio-management-pms-investment-advisory/'
    },
    {
      id: 'compass',
      title: 'Compass: Personal Finance Blog',
      description: "Getting more out of your money",
      Icon: BookOpen,
      category: 'Blogs',
      externalLink: "https://maxiomwealth.com/blog/category/financial-planning-money-matters-investment-advisor/"
    },
    {
        id: 'invest',
        title: 'Investment Basics Blog',
        description: 'Learn the fundamentals of investing',
        Icon: BookOpen,
        category: 'Learning Center',
        externalLink: "https://maxiomwealth.com/blog/category/investing-fundamentals-mutual-funds-guide/"
      },
      {
        id: 'maxiom-academy',
        title: 'Maxiom Academy & Certification',
        description: "Get certified and test your Fin IQ",
        Icon: GraduationCap,
        category: 'Learning Center',
        externalLink: "https://club.maxiomwealth.com/dashboard/edu_home"
      },
      {
        id: 'askguru',
        title: 'Askguru: Trends, Q&A',
        description: "Blog on trending topics. Q&A.",
        Icon: TrendingUp,
        category: 'Trends, Q&A',
        externalLink: "https://maxiomwealth.com/askguru/"
      },
      // {
      //   id: 'twitter',
      //   title: 'Maxiom @ Twitter',
      //   description: "Follow our latest updates and insights",
      //   Icon: Twitter,
      //   category: 'Trends, Q&A',
      //   externalLink: "https://x.com/maxiomwealth"
      // },
      // {
      //   id: 'linkedin',
      //   title: 'Maxiom @ LinkedIn',
      //   description: "Connect with us on LinkedIn",
      //   Icon: Link,
      //   category: 'Trends, Q&A',
      //   externalLink: "https://www.linkedin.com/company/maxiomwealth/"
      // },
      {
        id: 'podcast',
        title: 'Podcast',
        description: "Listen to M2M podcast by Manoj and Medury on market insights",
        Icon: Headphones,
        category: 'Podcast',
        externalLink: "https://www.youtube.com/playlist?list=PLf2WkbohH-nZF4HwTcXaLWj9qbzMQrB6z"
      }
  ];
